import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Share2, TrendingUp, Users } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { TabsContent } from '../../ui/tabs';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ReferralsTab = ({ ctx }) => {
  const { token } = ctx;
  const [data, setData] = useState({ referrals: [], total: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${API}/admin/referrals`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setData(res.data);
      } catch {
        // negeer
      } finally {
        setLoading(false);
      }
    })();
  }, [token]);

  return (
    <TabsContent value="referrals" className="space-y-6">
      <Card className="border-0 shadow-sm">
        <CardHeader>
          <CardTitle className="text-lg font-semibold flex items-center gap-2">
            <Share2 className="w-5 h-5 text-gold" />
            Referrals / Virale Bronnen
          </CardTitle>
        </CardHeader>
        <CardContent>
          {loading ? (
            <p className="text-muted-foreground py-6 text-center text-sm">Laden...</p>
          ) : data.total === 0 ? (
            <p className="text-muted-foreground py-6 text-center text-sm">
              Nog geen bezoekers via een UTM-bron geregistreerd.
            </p>
          ) : (
            <>
              <div className="mb-4 p-4 rounded-xl bg-gold/10 border border-gold/30 flex items-center gap-3">
                <TrendingUp className="w-8 h-8 text-gold" />
                <div>
                  <div className="text-2xl font-bold text-foreground" data-testid="referrals-total">
                    {data.total}
                  </div>
                  <div className="text-xs text-muted-foreground">
                    totaal bezoeken via gedeelde links
                  </div>
                </div>
              </div>
              <div className="space-y-2">
                {data.referrals.map((r) => (
                  <div
                    key={r.source}
                    data-testid={`referral-${r.source}`}
                    className="flex items-center justify-between p-3 rounded-lg bg-muted/30 hover:bg-muted/50 transition-colors"
                  >
                    <div className="flex items-center gap-3">
                      <Users className="w-4 h-4 text-muted-foreground" />
                      <div>
                        <div className="font-bold text-foreground">{r.source}</div>
                        {r.last_at && (
                          <div className="text-xs text-muted-foreground">
                            Laatste: {new Date(r.last_at).toLocaleString('nl-NL')}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="text-2xl font-bold text-gold">{r.count}</div>
                  </div>
                ))}
              </div>
            </>
          )}
        </CardContent>
      </Card>
    </TabsContent>
  );
};
